import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"]}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/react-quill/dist/quill.snow.css");
;
import(/* webpackMode: "eager", webpackExports: ["AlertDialogViewport"] */ "/opt/render/project/src/src/components/alert-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AskDialogViewport"] */ "/opt/render/project/src/src/components/ask-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConfirmDialogViewport"] */ "/opt/render/project/src/src/components/confirm-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dev"] */ "/opt/render/project/src/src/components/dev.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DrawerViewport"] */ "/opt/render/project/src/src/components/drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FcmMessageReceiver"] */ "/opt/render/project/src/src/components/fcm-message-receiver.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StopImpersonationButton"] */ "/opt/render/project/src/src/components/impersonation-banner/stop-impersonation-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/render/project/src/src/components/ui/toaster.tsx");
